



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Dropdown from '@/components/shared/Dropdown.vue';
import { KeyringPair } from '@polkadot/keyring/types';
import keyring from '@polkadot/ui-keyring';
import Balance from '@/params/components/Balance.vue';
import { notificationTypes,  showNotification } from '@/utils/notification';
import exec from '@/utils/transactionExecutor';

@Component({
  components: {
		Dropdown,
		Balance,
  },
})
export default class SubmitProposal extends Vue {
	private account: any = {};
	private password: string = '';
	private hash: string = '';
  private tx: string = '';
  private balance: number = 0;

  public handleAccountSelection(account: KeyringPair) {
		this.account = account;
		
	}

	public async shipIt() {
		const { api } = (this as any).$http;

		if (!api) {
			return;
		}
		
		try {
			showNotification('Dispatched');
			const { hash, balance } = this;
			this.tx = await exec(this.account, this.password, api.tx.democracy.propose, [hash, balance]);
			showNotification(this.tx, notificationTypes.success);
		} catch (e) {
			showNotification(e, notificationTypes.danger);
		}

	}
	
	public handleValue(value: any) {
    console.log(value);
    
    Object.keys(value).map((item) => {
      (this as any)[item] = value[item];
    });
	}
	
}
